(() => {
	'use strict';

	angular
		.module('uwAgenda.email')
		.controller(
			'EmailTableController',
			[
				'$state',
				'$uibModal',
				'Email',
				'MessagePaginationService',
				'SharedAgendaService',
				'DownloadService',
				'ExportFormat',
				'EmailService',
				EmailTableControllerFn
			]);

	/* controller for email table */
	function EmailTableControllerFn(
		$state,
		$uibModal,
		Email,
		MessagePaginationService,
		SharedAgendaService,
		DownloadService,
		ExportFormat,
		EmailService) {
		const vm = this;

		vm.overview = null;
		// start
		activate();

		// add new row to table
		vm.new = function () {
			// check mainuser email
			const mainEmail = SharedAgendaService.currentUser().mainEmail;
			if (mainEmail === undefined || mainEmail === null || mainEmail === '') {
				showMessage();
			}
			else {
				// mail object
				const email = new Email();
				// write new mail
				const modalInstance = EmailService.write(email);

				// when modal is closed
				modalInstance.result.then(function (item) {
					
				});
			}
		};

		// show all
		vm.showAll = function () {
			$state.go($state.current.name, { all: vm.overview.data.showAll }, { reload: $state.current.name });
		};

		// export
		vm.export = function () {
			const emailIds = [];
			for (let i = 0; i < vm.overview.data.results.length; i++) {
				emailIds.push(vm.overview.data.results[i].id);
			}

			if (emailIds.length > 0) {
				DownloadService.exportFilteredEmails(SharedAgendaService.currentUser().id, emailIds).then(function (response) {
					DownloadService.openReport(ExportFormat.CSV.value, response, "email");
				});
			}
		};

		// show info message if no email configured
		function showMessage() {
			// show modal
			$uibModal.open({
				keyboard: false,
				animation: true,
				templateUrl: '/app/email/overview/templates/email-detail-message.template.html',
				controller: 'DetailEmailMessageController',
				controllerAs: 'vm',
				size: 'xs'
			});
		}
		
		function activate() {
			vm.overview = MessagePaginationService;
		}
	}
})();
